module.exports = __webpack_public_path__ + "img/pn-logo.9932c5a6.png";